// extracted by mini-css-extract-plugin
export default {"container":"Info_container__yDPSz","title":"Info_title__BtB6H","subtitle":"Info_subtitle__bHuXS","text":"Info_text__3H+65","headerLabelOrg":"Info_headerLabelOrg__kxrIR"};